
// 需要添加字符串的服务
const needAddStr = ['API_SERVICES', 'KEYWORD_RANKING_ACQUISITION', 'AI_GENETATE_REVIEW']
// 不需要保存的服务
const notNeedSaveDraft = ['ASO_SERVICE', 'API_SERVICES', 'KEYWORD_RANKING_ACQUISITION', 'AI_GENETATE_REVIEW']

export {
  needAddStr,
  notNeedSaveDraft
}
